@if (temporaryInformationContent() && temporaryInformationContent().length > 0) {
  <h2 class="text-2xl font-bold mb-2 text-grey-0">Aktuell information</h2>
  <div class="description">
    @for (content of temporaryInformationContent(); track content) {
      <p>{{ content }}</p>
    }
  </div>
}

@if (careproviderUnit()?.description) {
  <h2 class="text-2xl font-bold mb-2">Om mottagningen</h2>

  <div
    [dataLayerParamsClickGA4]="dataLayerParamsClickGA4()"
    [innerHTML]="careproviderUnit().description"
    appStaticAdClick
    appStaticRedirectClick
    class="description"
  ></div>

  @if (careproviderUnit().updatedAt !== null && careproviderUnit().updatedAt !== '') {
    <p>
      <em>Informationen uppdaterades {{ updateDateFormatted() }}</em>
    </p>
  }

  @if (landingPageRoute()) {
    <app-ui-button
      [routerLink]="landingPageRoute()"
      color="green"
      expanded="inline"
      size="lg"
    >
      <app-ui-icon name="external"></app-ui-icon>
      Mer om {{ careproviderUnit().name }}
    </app-ui-button>
  }

}

